<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Penyesuaian Keputusan" >

        <w-flex justify-center align-center>
            <div class="xs7">
                  <h5 class="fw-semibold m0">
                      Jenis Fail : 
                  </h5>
                  <div class="fw-normal my1 fs-1">KAUNTER </div>
            </div>
          </w-flex>
          <w-flex justify-center align-center>
            <div class="xs7">
                  <h5 class="fw-semibold m0">
                      Penyata Bank :
                  </h5>
                  <div class="fw-normal my1 fs-1"> BIMB202229898778.txt</div>
            </div>
            </w-flex>
          <w-flex justify-center align-center>
            <div class="xs7">
                  <h5 class="fw-semibold m0">
                     Jumlah Rekod :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 200 </div>
            </div>
            </w-flex>
          <w-flex justify-center align-center>
            <div class="xs7">
                  <h5 class="fw-semibold m0">
                      Jumlah Rekod Sepadan :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 190</div>
            </div>
            </w-flex>
          <w-flex justify-center align-center>
            <div class="xs7">
                  <h5 class="fw-semibold m0">
                      Jumlah Rekod Ralat :
                  </h5>
                  <div class="fw-normal my1 fs-1"> 10 </div>
            </div>

        </w-flex>
        <w-flex class="mt4" wrap align-center justify-end>
                    <w-button bg-color="error-dark1" dark tile @click="destroy(item)">
                         <w-icon dark tile >fal fa-times</w-icon>
                    </w-button>
                    &nbsp;
                    <!-- <w-button bg-color="warning-dark1" tile @click="edit(item)">
                        <w-icon dark tile >fal fa-arrow-circle-left</w-icon>
                     </w-button>
                     &nbsp;
                     <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                        <w-icon dark tile >fal fa-save</w-icon>
                    </w-button> -->
            </w-flex>

    
  
        

        
      
        
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'

export default {
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
    jenis:'',
    no:'',
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
      resourceurl: 'deposit',
      reload: true,
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Penyesuaian', route: '/bayaran' },
      ],
    }
  },
  methods: {
    onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
    this.$inertia.visit(window.route('bayaran.index'));

  },
  
  },
  watch: {

  },
  mounted() {
    
      
  },
}
</script>